"use client";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./3D6OCOHF.js";
import {
  createStoreContext
} from "./5M6RSQEC.js";

// src/tab/tab-context.tsx
var ctx = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useTabContext = ctx.useContext;
var useTabScopedContext = ctx.useScopedContext;
var useTabProviderContext = ctx.useProviderContext;
var TabContextProvider = ctx.ContextProvider;
var TabScopedContextProvider = ctx.ScopedContextProvider;

export {
  useTabContext,
  useTabScopedContext,
  useTabProviderContext,
  TabContextProvider,
  TabScopedContextProvider
};
